import { ReactElement, ReactNode, useState } from "react";
import CaretDownIcon from "./CaretDownIcon";

export default function Accordion({
  title,
  className = "",
  children,
  expanded = false,
  hideTitleOnExpand = false,
}: {
  title: ReactNode;
  className?: string;
  children: ReactElement;
  expanded?: boolean;
  hideTitleOnExpand?: boolean;
}) {
  const [expand, setExpand] = useState(expanded);

  return (
    <div className={`w-full flex flex-col py-2 ${className}`}>
      <div
        onClick={() => setExpand(!expand)}
        className="cursor-pointer flex justify-between gap-4"
      >
        <div className="grow">{(!expand || !hideTitleOnExpand) && title}</div>
        <CaretDownIcon expanded={expand} />
      </div>
      {expand && children}
    </div>
  );
}
